<!--create-playList start-->
<div class="create-playList">
    <!--create-playList button start-->
    <button (click)="openCreatePlayListDialog()">

        <!--create-playList button icon start-->
        <span class="material-symbols-outlined">
            queue_music
        </span>
        <!--create-playList button icon end-->

        <!--create-playList button text start-->
        <span>
            Create playlist
       </span>
        <!--create-playList button text end-->

    </button>
</div>
<!--create-playList end-->
